import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';

export default ($) => {
    const prevHtml = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22" fill="none">
  <path d="M11 1L1 11L11 21" stroke="#666666"/>
</svg>`;
    const nextHtml = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22" fill="none">
  <path d="M1 1L11 11L1 21" stroke="#666666"/>
</svg>`;
    const control = $("#book-now");
    const form = control.find("form");
    const submitButton = control.find(".submit-button");
    const oneDay = (1000 * 60 * 60 * 24);
    const dp = new AirDatepicker('#el', {
        locale: localeEn,
        onSelect: (event) => {
            const { date, formattedDate } = event;
            if (date.length == 2) {
                ci.value = formattedDate[0];
                const days = (date[1].getTime() - date[0].getTime()) / oneDay;
                nights.value = Math.round(days).toFixed(0);
            }
            else {
                ci.value = formattedDate;
            }
            updateUrl();
        },
        onBeforeSelect: ({ date, datepicker }) => {
            if (date < now)
                return false;
            return true;
        },
        dateFormat: 'M/d/yyyy',
        range: false,
        navTitles: { days: "MMMM" },
        prevHtml,
        nextHtml
    });
    jQuery(".date-input").each(function () {
        const input = this;
        const dp = new AirDatepicker(input, {
            locale: localeEn,
            dateFormat: 'M/d/yyyy',
            onSelect: (event) => {
                $(input).trigger("change");
                dp.hide();
            },
            isMobile: true,
            navTitles: { days: "MMMM" },
            prevHtml,
            nextHtml
        });
    });
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    dp.selectDate(now);
    const ci = document.getElementById("check-in");
    const nights = document.getElementById("nights");
    ci.addEventListener("change", () => {
        if (ci.value) {
            const d = new Date(ci.value);
            if (d < now) {
                dp.selectDate(now);
            } else {
                dp.selectDate(ci.value);
            }
        } else {
            dp.selectDate([]);
        }
    });

    const target = $("[href='#book-now']").on("click", (e) => {
        const $link = $(e.target);
        e.preventDefault();
        control.slideToggle();
    }).attr("target");
    form.attr("target", target);
    submitButton.attr("target", target);
    submitButton.on("click", (e) => {
        e.preventDefault();
        form.submit();
    });

    const updateUrl = () => {
        const u = new URL(form.attr("action") + "?" + form.serialize());
        submitButton.attr("href", u);
    };
    form.on("change", "input,select", updateUrl);
    updateUrl();
};